import React from 'react';
import Form from '../../../components/common/Form';

class SubscribersPerChannel extends Form {
    constructor(props) {
        super(props);
        this.state = {
            subscribers_count_total: this.props.subscribers_count_total,
            subscribers_count_wp_total: this.props.subscribers_count_wp_total,
            facebook_pages_total: this.props.facebook_pages_total,
            errors: {}
        };
    }

    componentDidUpdate=()=>{
        if(this.state.subscribers_count_total !== this.props.subscribers_count_total)
        {
            this.setState({
                subscribers_count_total: this.props.subscribers_count_total
            });
        }
        if(this.state.facebook_pages_total !== this.props.facebook_pages_total) {
            this.setState({
                facebook_pages_total: this.props.facebook_pages_total
            });
        }
        if(this.state.subscribers_count_wp_total !== this.props.subscribers_count_wp_total)
        {
            this.setState({
                subscribers_count_wp_total: this.props.subscribers_count_wp_total
            });
        }
    }

    render() {
        const {subscribers_count_total, facebook_pages_total, subscribers_count_wp_total} = this.state;

        const facebook_pages_totals =
            <div className="col-xs-12">
                <p className="text-bold m-xs-b">
                    <span className="fab fa-facebook-messenger"></span> Facebook messenger
                </p>
                <div className="separator m-k-b"></div>
                {facebook_pages_total.map(page =>
                        <label key={page.id}>{page.fb_page} <span className="right">{page.subscribers_count}</span></label>
                )}
            </div>;

            return (
                <div className="col-xl-3">
                    <p>Subscribers Per Channel</p>
                    <label className="grey-text m-b-lg">Current Status</label>
                    <span className="subs text-bold m-k-b">{subscribers_count_total}</span>

                    <div className="row subs-per-channel m-m-t">
                        {facebook_pages_totals}
                    </div>
                    {subscribers_count_wp_total ?   <div className="row subs-per-channel m-m-t">
                        <div className="col-xs-12">
                            <p className="text-bold m-xs-b">
                                <span className="fab fas fa-globe"></span> Web Push <span className="right">{subscribers_count_wp_total}</span>
                            </p>
                            <div className="separator"></div>
                        </div>
                    </div>
                        :
                        ""
                    }

                </div>
            )
    }
}

/* <div className="row subs-per-channel m-m-t">
 {slack_channels_totals}
 </div>*/

export default SubscribersPerChannel